import {mapGetters} from 'vuex'
import {BankAccountStates, BankTranTypes} from '@/util/constants'

export default {
  computed: {
    ...mapGetters([
      'getConfig',
      'getSelectedCompany',
      'getPrimaryDebitBankAccount',
      'getPrimaryDepositBankAccount',
    ]),
  },
  methods: {
    bankAccountStateByTranType(tranType) {
      switch (tranType) {
        case BankTranTypes.DEBIT:
          if (this.getSelectedCompany.directDebit)
            return BankAccountStates.ACTIVE
          if (this.getPrimaryDebitBankAccount) return BankAccountStates.PENDING
          break
        case BankTranTypes.DEPOSIT:
          if (this.getSelectedCompany.directDeposit)
            return BankAccountStates.ACTIVE
          if (this.getPrimaryDepositBankAccount)
            return BankAccountStates.PENDING
          break
      }
      return BankAccountStates.NOT_ACTIVE
    },
    getMatchingCountry(countryCode) {
      const matchingCountry = Object.values(this.getConfig('COUNTRIES')).filter(
        (country) => country.code === countryCode
      )
      return matchingCountry.length > 0 ? matchingCountry[0] : false
    },
    getCountries() {
      return Object.values(this.getConfig('COUNTRIES')).map((country) => {
        return {value: country.code, text: country.name}
      })
    },
    getStates(countryCode) {
      const matchingCountry = this.getMatchingCountry(countryCode)
      if (matchingCountry)
        return matchingCountry.states.map((state) => {
          return {value: state.code, text: state.name}
        })
      return []
    },
  },
}
